import React from 'react';
import { graphql } from 'gatsby';
import { Layout, routes, pageTypes, siteDescription, siteName, AdMobileAnchor, AdMobileBanner, AdLeaderboard } from 'gatsby-theme-apollo';
import Footer from './footer';
import GameContent from './content';
import Section from '../layout/section';
import PatchPreviewCards from '../cards/patch-preview-card';
import EmptyState from '../status/empty-state';

const EntityHubPage = ({ location, data }) => {
  const pageType = pageTypes.PATCH_HUB;
  const { cms } = data;
  const { game } = cms;
  const { patches: patchPreviews } = game;
  const gameName = game && game.name;

  const pageTitle = `${game.name} Patch Notes | ${siteName}`;
  const pageDescription = `The latest patch notes for ${game.name}. ${siteDescription}`;
  const crumbs = [{ text: `${game.name} Wiki`, url: routes.GameHub(game.name), hide: true }];

  return (
    <Layout
      location={location}
      gameName={gameName}
      title={pageTitle}
      description={pageDescription}
      pageType={pageType}
    >
      <AdMobileAnchor placementId={'gh-anchor-' + pageType +'-bottom'} anchorType='bottom' offset='47' />
      <GameContent header={`${gameName} Patch Notes `} crumbs={crumbs} showTopShareBar>
        <AdMobileBanner placementId={"gh-mobilebanner-" + pageType + "-top"} />
        <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
        
        {patchPreviews && patchPreviews.length > 0 ? (
          <Section>
            <PatchPreviewCards patchPreviews={patchPreviews} showGameName />
          </Section>
        ) : (
          <EmptyState>
            No patch notes yet! Check back soon.
            <span role="img" aria-label="thumbs up">
              👍
            </span>
          </EmptyState>
        )}
        <Footer />
      </GameContent>
    </Layout>
  );
};

export default EntityHubPage;

export const pageQuery = graphql`
  query($gameID: ID!) {
    cms {
      game(id: $gameID) {
        id
        name
        patches(sort: "createdAt:DESC") {
          id
          game {
            name
          }
          version
          createdAt
          description
          heroImage {
            url
          }
        }
      }
    }
  }
`;
